import { useEffect } from 'react';

export const usePageMetadata = (title: string, description: string) => {
  useEffect(() => {
    const previousTitle = document.title;
    const existingDescription = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;
    const previousDescription = existingDescription?.content;
    const descriptionMeta = existingDescription || document.createElement('meta');
    const createdDescription = !existingDescription;

    document.title = title;
    descriptionMeta.setAttribute('name', 'description');
    descriptionMeta.content = description;
    if (createdDescription) {
      document.head.appendChild(descriptionMeta);
    }

    return () => {
      document.title = previousTitle;
      if (createdDescription) {
        descriptionMeta.remove();
      } else if (previousDescription !== undefined) {
        descriptionMeta.content = previousDescription;
      }
    };
  }, [description, title]);
};
